import {
  LOAD_RECIPIENTS,
  SET_RECIPIENTS,
  ADD_RECIPIENT,
  LOAD_RECIPIENT,
  SET_RECIPIENT,
  CREATING_RECIPIENT,
  CLEAR_RECIPIENT_OBJECT,
  RESET_RECIPIENT_STATE,
  LOAD_RECIPIENT_LIST,
  SET_RECIPIENT_LIST,
  SET_RECIPIENT_ERRORS,
  SET_RECIPIENT_LIST_RECORDS,
  SET_RECIPIENT_LIST_ECOMMERCE_RECORDS,
  SET_RECIPIENT_LIST_DETAILS,
  SET_RECIPIENT_TYPE,
  SET_SELECTED_RECIPIENT_LIST,
  SET_RECIPIENTLIST_TOTAL_COUNT,
  SET_SELECTED_ECOMMERCE_RECIPIENT_LIST,
  SET_ORDER_RECIPIENT_LIST,
  DELETE_SELECTED_RECIPIENT_LIST
} from '../mutationTypes'
import getRecipientStoreDefaultState from '@/state/recipientStore/recipientStoreDefaultState'

export default {
  [SET_RECIPIENT_LIST_DETAILS](state, payload) {
    state.recipientListDetails = payload
  },
  [SET_RECIPIENT_LIST_RECORDS](state, payload) {
    state.recipientListRecords = payload
  },
  [SET_RECIPIENT_LIST_ECOMMERCE_RECORDS](state, payload) {
    state.recipientListEcommerceRecords = payload
  },
  [SET_RECIPIENT_ERRORS](state, payload) {
    state.recipientErrors = payload
  },
  [LOAD_RECIPIENT_LIST](state, payload) {
    state.loadRecipientList = payload
  },
  [SET_RECIPIENT_LIST](state, payload) {
    state.recipientList = payload
  },
  [SET_ORDER_RECIPIENT_LIST](state, payload) {
    state.orderRecipientList = payload
  },
  [SET_SELECTED_ECOMMERCE_RECIPIENT_LIST](state, payload) {
    if (payload.type === 'mutiple') {
      state.selectedEcommerceRecipientList.push(payload.users)
    }
  },
  [DELETE_SELECTED_RECIPIENT_LIST](state, id) {
    const index = state.selectedRecipientList.findIndex(list => list.id === id)
    state.selectedRecipientList.splice(index, 1)
  },
  [SET_SELECTED_RECIPIENT_LIST](state, payload) {
    console.log({ payload })
    if (payload) {
      // Handle selection and deselecting
      if (state.selectedRecipientList.find(list => list.id === payload.id)) {
        state.selectedRecipientList = state.selectedRecipientList.filter(
          list => list.id !== payload.id
        )

        console.log({ state: state.selectedRecipientList })
      } else {
        state.selectedRecipientList.push(payload)
      }
    } else {
      state.selectedRecipientList = []
    }
  },
  [DELETE_SELECTED_RECIPIENT_LIST](state, id) {
    const index = state.selectedRecipientList.findIndex(list => list.id === id)
    state.selectedRecipientList.splice(index, 1)
  },
  [SET_ORDER_RECIPIENT_LIST](state, payload) {
    state.orderRecipientList = payload
  },
  [SET_SELECTED_ECOMMERCE_RECIPIENT_LIST](state, payload) {
    if (payload.type === 'mutiple') {
      state.selectedEcommerceRecipientList.push(payload.users)
    } else {
      state.selectedEcommerceRecipientList = payload.users
    }
  },
  [SET_RECIPIENT_TYPE](state, payload) {
    state.recipientType = payload
  },
  [LOAD_RECIPIENTS](state, payload) {
    state.loadRecipients = payload
  },
  [SET_RECIPIENTS](state, payload) {
    state.recipients = payload
  },
  [ADD_RECIPIENT](state, payload) {
    state.recipients.push(payload)
  },
  [CREATING_RECIPIENT](state, payload) {
    state.creatingRecipient = payload
  },
  [LOAD_RECIPIENT](state, payload) {
    state.loadRecipient = payload
  },
  [SET_RECIPIENT](state, payload) {
    state.recipient = payload
  },
  [CLEAR_RECIPIENT_OBJECT](state) {
    state.newRecipient = {
      name: '',
      email: '',
      address_one: '',
      address_two: '',
      phone: '',
      city: '',
      country: '',
      state: '',
      zipcode: '',
      salesforce_resource_uid: null
    }
  },
  [RESET_RECIPIENT_STATE](state) {
    Object.assign(state, getRecipientStoreDefaultState())
  },
  [SET_RECIPIENTLIST_TOTAL_COUNT](state, payload) {
    state.recipientTotal = payload
  }
}
